import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';

import { transformRequest } from '../transformers/request';
import { paramsSerializer, transformResponse } from '../transformers/response';

export const createApiClient = (
  baseURL: string,
  options?: Partial<Omit<CreateAxiosDefaults, 'baseURL'>>,
): AxiosInstance => {
  return axios.create({
    baseURL,
    responseType: 'json' as const,
    validateStatus: (status) => status >= 200 && status < 300 && status !== 208,
    headers: {
      'Content-Type': 'application/json',
    },
    transformRequest,
    paramsSerializer,
    transformResponse,
    ...options,
  });
};
